<template>
  <b-row>
    <b-col cols="12" md="4" offset-md="4">
      <div v-if="!error && !processed" class="d-flex justify-content-center align-items-center">
        <b-card>
          <!-- Card title -->
          <b-card-title class="mb-1">
            Email Suffix Request
          </b-card-title>

          <p>A new user has requested that you add the following suffix to your company's list of approved email suffixes</p>

          <h4 class="mb-2">@{{ suffix }}</h4>

          <div>
            <b-button variant="success" @click="handleUserClick(true)">Accept</b-button>
            <b-button variant="danger" class="ml-2" @click="handleUserClick(false)">Reject</b-button>
          </div>
        </b-card>
      </div>
      <div v-else-if="error">
        <b-card>
          <p>Action has already been taken on the requested email suffix</p>
          <b-button :to="{ name: 'companyoverview' }">Go to company admin dashboard</b-button>
        </b-card>
      </div>
      <div v-else-if="!error && processed">
        <b-card>
          <p>Thank you, we have processed your decision</p>
          <b-button :to="{ name: 'companyoverview' }">Go to company admin dashboard</b-button>
        </b-card>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardTitle,
  BButton,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ApproveNewSuffix',
  components: {
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BButton,
  },
  props: {
    suffixPendingId: {
      type: [String],
      default: 'empty',
    },
  },
  data() {
    return {
      hasAccess: false,
      suffix: '',
      error: false,
      processed: false,
    }
  },
  computed: {
    ...mapGetters('auth', [
      'isCompanyAdmin',
    ]),
  },
  created() {
    this.hasAccess = this.isCompanyAdmin
    if (this.hasAccess) {
      this.getSuffix()
    } else {
      this.$router.push({ name: 'home' })
    }
  },
  methods: {
    getSuffix() {
      this.$http.get('companymanagment.cfc?method=getPendingSuffix', {
        params: { id: this.suffixPendingId },
      })
        .then(response => {
          if (response.data.status) {
            this.suffix = response.data.suffix
          } else {
            this.error = true
          }
        })
    },
    handleUserClick(accept) {
      this.$http.post('companymanagment.cfc?method=processSuffixResponse', new URLSearchParams({
        approve: accept,
        suffixpendingid: this.suffixPendingId,
      }))
        .then(response => {
          if (response.data.status) {
            this.processed = true
          } else {
            this.error = true
          }
        })
    },
  },
}
</script>
